/**
 * Whether the hub is showing the section that `el` belongs to.
 *
 * The hub keeps visited sections mounted and hides inactive ones with
 * `visibility: hidden` on a light DOM ancestor, outside the section's shadow
 * root, so this walks up through shadow roots to their hosts. It doesn't look at
 * the browser tab; check `document.visibilityState` for that.
 */
export function isSectionVisible(el: Element): boolean {
  let node: Element | null = el
  while (node) {
    const style = getComputedStyle(node)
    if (style.visibility === "hidden" || style.display === "none") {
      return false
    }
    // If we hit a shadow root, jump to the host element in the light DOM
    const root = node.getRootNode()
    node = root instanceof ShadowRoot ? root.host : node.parentElement
  }
  return true
}
